import Cookies from "js-cookie";
import {
  CREATE_BLOG_ADMIN_URL,
  UPDATE_BLOG_ADMIN_URL,
  DELETE_BLOG_ADMIN_URL,
  GET_BLOG_ADMIN_URL,
  GET_BLOG_ADMIN_SINGLE_URL,
  CREATE_BLOG_INSTITUTION_URL,
  UPDATE_BLOG_INSTITUTION_URL,
  DELETE_BLOG_INSTITUTION_URL,
  GET_BLOG_INSTITUTION_URL,
  GET_BLOG_INSTITUTION_SINGLE_URL,
  GET_BLOG_TEACHER_URL,
  GET_BLOG_TEACHER_SINGLE_URL,
  CREATE_BLOG_TEACHER_URL,
  UPDATE_BLOG_TEACHER_URL,
  DELETE_BLOG_TEACHER_URL,
} from "../apiurls/apiurls";

const isAdmin = () => Cookies.get("role") === "admin";
const isTeacher = () => Cookies.get("role") === "teacher";

const getAuthToken = () =>
  isAdmin() ? Cookies.get("admin_token") : Cookies.get("institution_token");

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getBlogs = async (courseKey) => {
  try {
    const baseGetUrl = isAdmin()
      ? GET_BLOG_ADMIN_URL
      : isTeacher()
        ? GET_BLOG_TEACHER_URL
        : GET_BLOG_INSTITUTION_URL;
    let url = baseGetUrl;

    if (typeof courseKey === "string" && courseKey.trim()) {
      const params = new URLSearchParams({ course: courseKey.trim() });
      url = `${baseGetUrl}?${params.toString()}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data)
        ? data
        : [];
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const getBlog = async (id) => {
  if (!id) throw new Error("Blog id is required to fetch");

  try {
    const baseGetSingleUrl = isAdmin()
      ? GET_BLOG_ADMIN_SINGLE_URL
      : isTeacher()
        ? GET_BLOG_TEACHER_SINGLE_URL
        : GET_BLOG_INSTITUTION_SINGLE_URL;
    const url = `${baseGetSingleUrl}?id=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data?.data || data;
  } catch (error) {
    console.error("Error fetching blog:", error);
    throw error;
  }
};

export const createBlog = async (payload, courseKey) => {
  try {
    const finalPayload =
      typeof courseKey === "string" && courseKey.trim()
        ? { ...payload, course: courseKey.trim() }
        : payload;

    const createUrl = isAdmin()
      ? CREATE_BLOG_ADMIN_URL
      : isTeacher()
        ? CREATE_BLOG_TEACHER_URL
        : CREATE_BLOG_INSTITUTION_URL;

    const response = await fetch(createUrl, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(finalPayload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating blog:", error);
    throw error;
  }
};

export const updateBlog = async (id, payload) => {
  if (!id) throw new Error("Blog id is required to update");

  try {
    const baseUpdateUrl = isAdmin()
      ? UPDATE_BLOG_ADMIN_URL
      : isTeacher()
        ? UPDATE_BLOG_TEACHER_URL
        : UPDATE_BLOG_INSTITUTION_URL;
    const url = `${baseUpdateUrl}?id=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};

export const deleteBlog = async (id) => {
  if (!id) throw new Error("Blog id is required to delete");

  try {
    const baseDeleteUrl = isAdmin()
      ? DELETE_BLOG_ADMIN_URL
      : isTeacher()
        ? DELETE_BLOG_TEACHER_URL
        : DELETE_BLOG_INSTITUTION_URL;
    const url = `${baseDeleteUrl}?id=${encodeURIComponent(id)}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error;
  }
};
